module.exports = __webpack_public_path__ + "img/vpc1.db6347e.png";